import styled from 'styled-components';

export const Main = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: end;
    flex-wrap: wrap;
    row-gap: 16px;
    column-gap: 16px;
    width: 100%;
`;

export const MainWrapper = styled.div`
    display: flex;
    row-gap: 9px;
    column-gap: 16px;
    width: auto;
    flex-wrap: wrap;
`;

export const SelectionSection = styled.div<{
    isShowing?: boolean;
}>`
    display: ${({ isShowing = true }) => (isShowing ? 'flex' : 'none')};
    flex-direction: column;
    row-gap: 6px;
    width: fit-content;
    justify-content: flex-end;
    height: 76px;
`;
